import { apiService } from './ApiService';
import { AxiosResponse } from 'axios';

export class SettingsService {
    private static instance: SettingsService;

    public static getInstance(): SettingsService {
        if (!SettingsService.instance) {
            SettingsService.instance = new SettingsService();
        }
        return SettingsService.instance;
    }

    public async getUserSettings(): Promise<AxiosResponse<any>> {
        return apiService.get('/api/user/settings/settings');
    }

    public async updateUserSettings(settings: any): Promise<AxiosResponse<any>> {
        return apiService.post('/api/user/settings/settings', settings);
    }

    public async setUserLanguage(language: string): Promise<AxiosResponse<any>> {
        return apiService.post('/api/user/language', { language });
    }

    public async setCatalogLanguage(language: string): Promise<AxiosResponse<any>> {
        return apiService.post('/api/user/set_catalog_language', { language });
    }

    public async uploadPricingFile(catalogName: string, file: File): Promise<AxiosResponse<any>> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('catalog_name', catalogName);

        // We need to access the underlying axios instance to send formData correctly with customized headers if needed,
        // but apiService.post handles json by default. apiService doesn't expose a clean way to override content-type for a single request 
        // without using the axiosInstance directly or passing config.
        // ApiService.post signature: (url, data, config)

        return apiService.post('/api/user/settings/upload-pricing', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    public async getWmiBrands(): Promise<AxiosResponse<{ brands: string[] }>> {
        return apiService.get('/api/user/settings/wmi-brands');
    }

    public async suggestCatalogBrands(config: any): Promise<AxiosResponse<{ brands: string[]; vendor_brands: string[] }>> {
        return apiService.post('/api/user/settings/suggest-brands', config, { timeout: 120000 });
    }

    public async testCatalogConfig(config: any): Promise<AxiosResponse<any>> {
        return apiService.post('/api/user/settings/test-config', config, { timeout: 120000 }); // 120 seconds timeout
    }
}

export const settingsService = SettingsService.getInstance();
